import { render } from "./chat-images.vue?vue&type=template&id=5a1a95e2"
import script from "./chat-images.vue?vue&type=script&lang=js"
export * from "./chat-images.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__